import { useSalesMarketingApi } from "./useSalesMarketingApi";
import qs from "qs";
import dayjs from "dayjs";

export const useLeisureAgreementActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    async function listAgreement(filters: any) {
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            name: filters.name ? filters.name : undefined,
            description: filters.description ? filters.description : undefined,
            status: filters.status ? filters.status : undefined,
            segmentCode: filters.segment ? filters.segment : undefined,
            leisureCode: filters.code ? filters.code : undefined,
            startDate: filters.startDate ? dayjs(filters.startDate).utcOffset(0).startOf("day").toISOString() : undefined,
            endDate: filters.endDate ? dayjs(filters.endDate).utcOffset(0).endOf("day").toISOString() : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let data = await GET("sm/leisure-agreement", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return data?.result;
    }

    function listCustomers() {
        return [
            {customerId: "1", customerName: "Customer 1"},
            {customerId: "2", customerName: "Customer 2"},
            {customerId: "3", customerName: "Customer 3"},
        ];
    }

    async function createAgreement(payload: any) {
        return await POST("sm/leisure-agreement/", payload, true);
    }

    async function updateAgreement(payload: any) {
        return await PUT("sm/leisure-agreement/", payload, true);
    }

    async function getDetailAgreement(id: any) {
        let res = await GET("sm/leisure-agreement/" + id, true);
        return res?.result;
    }

    /**
     * Conta le booking attive che dipendono dal binomio productCode + leisureCode
     * (scopata su tenant/dealer). Usato per impedire la rimozione di un product
     * code dall'accordo leisure quando esistono ancora prenotazioni vive (LPP-20956).
     *
     * @returns numero di booking attive (0 se nessuna o se la chiamata fallisce).
     */
    async function getProductActiveCount(productCode: string, leisureCode: string, tenantId: string, dealerId: string): Promise<number> {
        const res = await GET("sm/leisure-agreement/product-active-count", true, {
            params: {
                productCode,
                leisureCode,
                tenant: tenantId,
                dealer: dealerId
            }
        });
        return res?.activeCount ?? 0;
    }

    return {
        listAgreement,
        listCustomers,
        createAgreement,
        updateAgreement,
        getDetailAgreement,
        getProductActiveCount
    };
}